import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/animations/shift-away.css';
import 'tippy.js/themes/material.css';

const _s = {
    tippy: '[data-tippy-content]',
}

const normalizeTooltipContext = (context = document) => {
    if (context && typeof context.get === 'function') {
        return context.get(0) || document;
    }

    if (typeof context === 'string') {
        return document.querySelector(context) || document;
    }

    return context && typeof context.querySelectorAll === 'function' ? context : document;
};

export const initTooltips = (context = document) => {
    const scope = normalizeTooltipContext(context);
    const elements = [
        ...(scope.matches && scope.matches(_s.tippy) ? [scope] : []),
        ...Array.from(scope.querySelectorAll(_s.tippy)),
    ];

    elements.forEach((element) => {
        if (element._tippy) {
            element._tippy.destroy();
        }
    });

    if (!elements.length) {
        return [];
    }

    return tippy(elements, {
        allowHTML: true,
        animation: 'shift-away',
        theme: 'material',
        interactive: true,
        // interactive:true monterer ellers boblen i UDLØSERENS FORÆLDER — inde
        // i fx Samlets 22px ikonskal, hvor forfaderens containing block klemte
        // lange tekster til en 141px-strimmel, og gitterets overflow kunne
        // klippe boblen ved kanterne. På body får indholdet sin fulde bredde
        // (max 320px fra _tooltip.scss).
        appendTo: () => document.body,
    });
};

export class toolTip {
    constructor() {
        this.initTippy();
        this.ajaxCallback();
    }

    initTippy(context = document) {
        initTooltips(context);
    }

    ajaxCallback() {
        $(document).ajaxComplete((event, xhr, settings) => {
            if (settings.url.includes('wp-admin/admin-ajax.php')) {
                this.initTippy();
            }
        });

        $(document.body).on('popup_html_loaded', (event, action, selector) => {
            this.initTippy(selector);
        });
    }
}
